module.exports = __webpack_public_path__ + "static/media/allcall_textto911_hover.4c6d0bc2.svg";